import React from 'react';

const Speedway = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='13.999'
            viewBox='0 0 14 13.999'
            className={className}
        >
            <path
                id='Speedway'
                d='M69.755,449.978a4.925,4.925,0,0,0-2.093-1.148c-1.246-.278-2.506-.472-3.761-.7a6.316,6.316,0,0,1-2.924-1.171c-.126-.1-.187-.3-.287-.45-.07-.1-.148-.253-.234-.265a.429.429,0,0,0-.33.157,1.148,1.148,0,0,0-.139.379q-1.519,4.949-3.037,9.9c-.549,1.786-.332,1.113-.889,2.9-.079.254-.136.53.14.642.25.1.366-.12.443-.371.394-1.287.019-.114.418-1.4.32-1.031.64-2.063.972-3.128.108.068.18.121.257.16a10.816,10.816,0,0,0,1.979.964c1.169.306,2.371.451,3.561.643a6.182,6.182,0,0,1,3.138,1.349c.331.28.528.209.67-.246q1.162-3.745,2.315-7.493A.6.6,0,0,0,69.755,449.978Zm-2.035,5.483c-.208.652-.434,1.3-.646,1.917l-2.015-1.013.707-2.1a14.545,14.545,0,0,0-2.373-.4l.777-2.275c-.7-.115-1.392-.215-2.072-.349-.229-.046-.312.022-.38.231-.221.669-.459,1.332-.689,2l2.352.4c-.084.282-.163.565-.252.845-.113.357-.226.714-.357,1.064-.034.09-.145.224-.2.216-.754-.1-1.5-.225-2.315-.354l.761-2.159a4.582,4.582,0,0,1-1.727-.853.287.287,0,0,1-.1-.238c.242-.728.5-1.451.741-2.147l1.844.962.77-2.208,2.407.419-.707,2.079,2.386.383-.8,2.329c.3.128.6.233.875.384a8.848,8.848,0,0,1,.925.589A.323.323,0,0,1,67.72,455.462Zm1.541-4.485c-.21.66-.442,1.315-.657,1.941l-1.993-1.058c.054-.163.125-.383.2-.6.138-.4.288-.806.412-1.215.063-.206.165-.261.343-.17.526.272,1.055.541,1.574.829A.319.319,0,0,1,69.261,450.977Z'
                transform='translate(-55.995 -446.244)'
            />
        </svg>
    );
};

export default Speedway;
